import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const showToast = (message, type) => {
  const options = {
    position: "top-right",
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  switch (type) {
    case "success":
      toast.success(message, {
        ...options,
        className: "bg-success text-white",
        icon: false,
      });
      break;
    case "error":
      toast.error(message, {
        ...options,
        className: "bg-danger text-white",
        icon: false, // Remove the error icon
      });
      break;
    case "warning":
      toast.warning(message, {
        ...options,
        className: "bg-warning text-white",
      });
      break;
    case "info":
      toast.info(message, {
        ...options,
        className: "bg-info text-white",
      });
      break;
    default:
      toast(message, options);
      break;
  }
};
